import axios from 'axios';
import apiConfig from '../../api.config';

export default async function saveChannelConfig(hotel, channel, configs) {
  const {
    host,
    URIs: { hbxChannelSaveConfig },
  } = apiConfig;

  const uri = `${host}${hbxChannelSaveConfig}`
    .replace(':hotelId', hotel)
    .replace(':channelId', channel);

  return await axios.post(uri, { configs }).then(res => res.data);
}
